module.exports = __webpack_public_path__ + "img/2019-01-10-ingles-juridico-entenda-o-vocabulario-da-area-802x506.af6cbe03.jpg";